// S-4 `/auth/verified` — Landing после verify-deep-link. Source: stage-4-screens.md §5.4.
//
// Парсит ?status=ok|invalid|expired. 3 состояния → CTA.

import { Link, useSearch } from 'wouter';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MobileFrame } from '@/components/layout/MobileFrame';

type Status = 'ok' | 'invalid' | 'expired';

function parseStatus(search: string): Status {
  const v = new URLSearchParams(search).get('status');
  if (v === 'ok' || v === 'invalid' || v === 'expired') return v;
  return 'invalid';
}

const COPY: Record<
  Status,
  { icon: typeof CheckCircle2; tint: string; title: string; text: string; cta: string; to: string }
> = {
  ok: {
    icon: CheckCircle2,
    tint: 'text-primary-text bg-primary/10',
    title: 'Email подтверждён',
    text: 'Спасибо! Теперь можно войти в аккаунт.',
    cta: 'Войти',
    to: '/signin',
  },
  invalid: {
    icon: XCircle,
    tint: 'text-destructive bg-destructive/10',
    title: 'Ссылка недействительна',
    text: 'Ссылка повреждена или уже использована. Попробуйте зарегистрироваться заново.',
    cta: 'Зарегистрироваться заново',
    to: '/signup',
  },
  expired: {
    icon: Clock,
    tint: 'text-amber-700 bg-amber-100',
    title: 'Срок ссылки истёк',
    text: 'Срок действия ссылки закончился. Зарегистрируйтесь заново, чтобы получить новое письмо.',
    cta: 'Зарегистрироваться заново',
    to: '/signup',
  },
};

export function Verified() {
  const search = useSearch();
  const status = parseStatus(search);
  const c = COPY[status];
  const Icon = c.icon;

  return (
    <MobileFrame>
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-12 text-center">
        <div className={`mb-5 flex h-16 w-16 items-center justify-center rounded-surface ${c.tint}`}>
          <Icon className="h-8 w-8" />
        </div>
        <h1 className="mb-2 text-hl-title font-bold leading-tight">{c.title}</h1>
        <p className="mb-8 max-w-xs text-sm leading-relaxed text-muted-foreground">{c.text}</p>
        <Button asChild className="h-11 w-full max-w-xs text-sm font-semibold">
          <Link href={c.to}>{c.cta}</Link>
        </Button>
      </div>
    </MobileFrame>
  );
}
